import { Components, Theme } from '@mui/material';

export const MuiTabs = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderBottom: `1px solid ${theme.palette.neutral.outlineVariant}`,
    }),
  },
} as Components<Theme>['MuiTabs'];

export const MuiTab = {
  styleOverrides: {
    root: ({ theme }) => ({
      ...theme.typography.body2Bold,
      minHeight: 48,
      color: theme.palette.neutral.onSurfaceVariant,
      '&.error': {
        color: theme.palette.error.main
      },
      '&.Mui-selected': {
        '&.error': {
          color: theme.palette.error.main
        },
      },
      ...theme.createStateLayer('transparent')
    }),
  },
} as Components<Theme>['MuiTab'];